(function () {
  const config = {
    sectionsToUpdate: ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'cart-footer']
  };

  // Flag to prevent the script from reacting to its own updates
  let isUpdating = false;

  async function manageFreeGift() {
    // Prevent overlapping runs
    if (isUpdating) return;

    const giftId = window.freeGiftConfig ? window.freeGiftConfig.variantId : null;
    if (!giftId) return;

    try {
      isUpdating = true;

      const res = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await res.json();

      const giftInCart = cart.items.find((item) => item.variant_id === giftId);

      // All items that are NOT the free gift
      const otherItems = cart.items.filter((item) => item.variant_id !== giftId);

      // Filter out Gift Cards
      const qualifyingItems = otherItems.filter((item) => {
        const sku = item.sku || '';
        return !sku.startsWith('TP-GIFT');
      });

      let method = null;
      let body = null;

      if (qualifyingItems.length > 0) {

        if (!giftInCart) {
          // CASE 1: No gift in cart -> ADD IT
          method = 'POST';
          body = {
            items: [{ id: giftId, quantity: 1 }],
            sections: config.sectionsToUpdate.join(',')
          };
        } else if (giftInCart.quantity !== 1) {
          // CASE 2: Gift exists, but quantity is wrong (e.g. 2) -> FIX IT
          method = 'POST';
          body = {
            id: giftId.toString(),
            quantity: 1,
            sections: config.sectionsToUpdate.join(',')
          };
        }

      } else if (qualifyingItems.length === 0 && giftInCart) {
        // CASE 3: No qualifying items -> REMOVE GIFT
        method = 'POST';
        body = {
          id: giftId.toString(),
          quantity: 0,
          sections: config.sectionsToUpdate.join(',')
        };
      }

      if (method && body) {
        // Determine endpoint: 'add.js' uses {items:[]}, 'change.js' uses {id, quantity}
        const endpoint = body.items ? 'add.js' : 'change.js';

        const updateRes = await fetch(`${window.Shopify.routes.root}cart/${endpoint}`, {
          method: method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });

        const data = await updateRes.json();
        const sections = data.sections || {};
        const onCartPage = window.location.pathname.includes('/cart');

        // 1. Update Cart Drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && sections['cart-drawer']) {
          if (!onCartPage && cartDrawer.renderContents) {
            cartDrawer.renderContents(data);
          } else {
            // Fallback for themes that don't expose renderContents or are on cart page
            const div = document.createElement('div');
            div.innerHTML = sections['cart-drawer'];
            const newInner = div.querySelector('.drawer__inner') || div.querySelector('.cart-drawer');
            const currentInner = cartDrawer.querySelector('.drawer__inner') || cartDrawer.querySelector('.cart-drawer');

            if (newInner && currentInner) {
              currentInner.innerHTML = newInner.innerHTML;
            }
            // Handle empty state classes
            if (data.item_count === 0) {
              cartDrawer.classList.add('is-empty');
              const drawerFooter = cartDrawer.querySelector('.cart-drawer__footer');
              if (drawerFooter) drawerFooter.style.display = 'none';
            } else {
              cartDrawer.classList.remove('is-empty');
            }
          }
        }

        // 2. Update Cart Bubble/Icon
        const cartBubble = document.querySelector('#cart-icon-bubble');
        if (cartBubble && sections['cart-icon-bubble']) {
          const div = document.createElement('div');
          div.innerHTML = sections['cart-icon-bubble'];
          const newBubble = div.querySelector('#cart-icon-bubble');
          cartBubble.innerHTML = newBubble ? newBubble.innerHTML : div.innerHTML;
        }

        // 3. Update Main Cart Page Items
        const cartItems = document.querySelector('cart-items');
        if (cartItems && onCartPage && sections['main-cart-items']) {
          const div = document.createElement('div');
          div.innerHTML = sections['main-cart-items'];
          const newCartItems = div.querySelector('cart-items') || div.querySelector('.cart-items');
          if (newCartItems) cartItems.innerHTML = newCartItems.innerHTML;

          const mainCartSection = cartItems.closest('.cart');
          if (data.item_count === 0) {
            cartItems.classList.add('is-empty');
            if (mainCartSection) mainCartSection.classList.add('is-empty');
          } else {
            cartItems.classList.remove('is-empty');
            if (mainCartSection) mainCartSection.classList.remove('is-empty');
          }
        }

        // 4. Update Cart Footer
        const cartFooter = document.querySelector('#main-cart-footer');
        if (cartFooter && onCartPage) {
          if (data.item_count === 0) {
            cartFooter.classList.add('is-empty');
            cartFooter.style.display = 'none';
          } else {
            cartFooter.classList.remove('is-empty');
            cartFooter.style.display = '';

            if (sections['cart-footer']) {
              const div = document.createElement('div');
              div.innerHTML = sections['cart-footer'];
              const newFooter = div.querySelector('#main-cart-footer');
              if (newFooter) cartFooter.innerHTML = newFooter.innerHTML;
            }
          }
        }
      }
    } catch (e) {
      console.error('Free Gift Logic Error:', e);
    } finally {
      // Release lock so future updates can happen
      isUpdating = false;
    }
  }

  // Debounce Timer
  let timeout;
  const originalFetch = window.fetch;

  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(async (response) => {
      const url = arguments[0];

      // Check if the URL is a cart update
      // AND ensure we aren't currently running our own update (isUpdating)
      if (response.ok &&
          typeof url === 'string' &&
          (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) &&
          !url.includes('sections=') &&
          !isUpdating) {

        clearTimeout(timeout);
        timeout = setTimeout(manageFreeGift, 500);
      }
      return response;
    });
  };

  document.addEventListener('DOMContentLoaded', manageFreeGift);
})();